(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filters-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const boot = (root) => {
      if (root.dataset.msfBound) return;
      root.dataset.msfBound = '1';
      // « Voir les décors » referme : les filtres sont déjà appliqués au fil des clics.
      root.querySelector('[data-msf-apply]')?.addEventListener('click', () => {
        if (typeof root.close === 'function') root.close();
      });
      // Le nombre de filtres actifs sur le bouton, et le lien « Réinitialiser » : ils
      // suivent les cases, sans attendre le rechargement de la grille.
      const count = root.querySelector('[data-msf-count]');
      const reset = root.querySelector('[data-msf-reset]');
      const refresh = () => {
        const form = root.querySelector('[data-ref="filters-form"]');
        if (!form) return;
        let n = form.querySelectorAll('input[type="checkbox"]:checked').length;
        for (const el of form.querySelectorAll('input[name^="filter.v.price"]')) if (el.value.trim() !== '') { n += 1; break; }
        if (count) { count.textContent = String(n); count.hidden = n === 0; }
        if (reset) reset.hidden = n === 0;
      };
      // En phase de capture sur le document : un script du thème arrête la
      // propagation du « change » au-dessus du formulaire, le tiroir ne le
      // recevrait pas. Un court délai laisse la case prendre son état.
      document.addEventListener('change', (event) => {
        if (root.contains(event.target)) window.setTimeout(refresh, 30);
      }, true);
      refresh();
    };
    const start = () => { for (const el of document.querySelectorAll('side-menu-component.msf')) boot(el); };
    start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-echantillons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-echantillons')) {
    /**
     * Ajoute l'offre cliquée au panier, puis ouvre le tiroir panier comme le
     * reste du site. En cas d'échec, le message est annoncé (role="status").
     */
    class MsEchantillons extends HTMLElement {
      #controller = null;

      connectedCallback() {
        this.#controller = new AbortController();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-msech-add]');
          if (button) this.#add(button);
        }, { signal: this.#controller.signal });
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      #say(message, isError = false) {
        const status = this.querySelector('[data-msech-status]');
        if (!status) return;
        status.textContent = message;
        status.classList.toggle('is-error', isError);
        status.hidden = !message;
      }

      /** @param {HTMLButtonElement} button */
      async #add(button) {
        const id = parseInt(button.dataset.msechAdd ?? '', 10);
        if (!Number.isFinite(id) || button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        this.#say('Ajout au panier…');
        const drawer = document.querySelector('cart-drawer');
        try {
          const response = await fetch(window.Theme?.routes?.cart_add_url ?? '/cart/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: drawer?.dataset?.sectionId }),
          });
          const payload = await response.json().catch(() => null);
          if (!response.ok || !payload) throw new Error(payload?.description || 'cart');
          this.#say('');
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: { source: 'ms-echantillons', sections: payload.sections } } }));
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          if (!drawer) window.location.href = window.Theme?.routes?.cart_url ?? '/cart';
        } catch (error) {
          this.#say(error?.message && error.message !== 'cart' ? error.message : 'Ajout au panier impossible. Réessayez.', true);
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('ms-echantillons', MsEchantillons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-etanche-kit"] && !Shopify.designMode) return;
  try {
    {
  const msEtancheKit = () => {
    const cfgEl = document.querySelector('script[data-ms-etanche-kit]');
    if (!cfgEl) return;
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch { return; }
    let running = false;

    /** Surface facturée d'une ligne : « 2,8 m² » × quantité, ou la quantité (secours au m² entamé). */
    const lineM2 = (item) => {
      const raw = String(item.properties?.['Surface facturée'] || '').replace(',', '.');
      const m2 = parseFloat(raw);
      return Number.isFinite(m2) && m2 > 0 && String(item.sku || '').startsWith('MS-SM-') ? m2 * item.quantity : item.quantity;
    };

    async function sync() {
      if (running) return;
      running = true;
      try {
        const cart = await (await fetch(`${window.Theme?.routes?.cart_url ?? '/cart'}.js`, { headers: { Accept: 'application/json' } })).json();
        const m2 = cart.items.filter((i) => i.handle === cfg.etanche).reduce((sum, i) => sum + lineM2(i), 0);
        const need = m2 > 0 ? Math.ceil(m2 / cfg.m2PerKit - 1e-9) : 0;
        const kitLines = cart.items.filter((i) => i.variant_id === cfg.kit);
        const have = kitLines.reduce((sum, i) => sum + i.quantity, 0);
        if (need === have) return;

        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.dataset?.sectionId;
        let response;
        if (kitLines.length) {
          response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: kitLines[0].key, quantity: need, sections }),
          });
        } else {
          response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: cfg.kit, quantity: need }], sections }),
          });
        }
        const payload = await response.json().catch(() => null);
        if (!response.ok) return;
        if (!drawer && /\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: { source: 'ms-etanche-kit', sections: payload?.sections } } }));
      } catch (error) {
        console.error('Kit Étanche :', error);
      } finally {
        running = false;
      }
    }

    document.addEventListener('cart:updated', (event) => {
      if (event.detail?.data?.source === 'ms-etanche-kit') return;
      window.setTimeout(sync, 150);
    });
    // Au chargement, seulement si le panier n'est pas vide : pas de requête inutile sur chaque page.
    if (cfg.items > 0) sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', msEtancheKit, { once: true });
  else msEtancheKit();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-form-guard"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__msFormGuard) return;
    window.__msFormGuard = true;

    const MESSAGES = {
      tel: { required: 'Numéro de téléphone requis', invalid: 'Numéro de téléphone invalide' },
      email: { required: 'Adresse e-mail requise', invalid: 'Adresse e-mail invalide' },
      textarea: { required: 'Message requis' },
      other: { required: 'Ce champ est requis' },
    };

    /** @param {HTMLElement} field */
    const kindOf = (field) => {
      if (field.tagName === 'TEXTAREA') return 'textarea';
      if (field.type === 'tel' || field.type === 'email') return field.type;
      return 'other';
    };

    /**
     * Le message à afficher pour ce champ, ou une chaîne vide s'il est bon.
     * Un numéro est plausible de 8 à 15 chiffres (E.164), espaces, points,
     * tirets, parenthèses et « + » tolérés.
     * @param {HTMLInputElement|HTMLTextAreaElement} field
     * @returns {string}
     */
    const problem = (field) => {
      const kind = kindOf(field);
      const value = field.value.trim();
      const msg = MESSAGES[kind] ?? MESSAGES.other;
      if (!value) {
        if (!field.required) return '';
        return field.dataset.msgRequired || msg.required;
      }
      if (kind === 'tel') {
        const digits = value.replace(/\D/g, '');
        const shape = /^[+\d][\d\s().-]*$/.test(value);
        if (!shape || digits.length < 8 || digits.length > 15) return field.dataset.msgInvalid || msg.invalid;
      }
      if (kind === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
        return field.dataset.msgInvalid || msg.invalid;
      }
      return '';
    };

    let uid = 0;
    /**
     * @param {HTMLElement} field
     * @param {string} message vide : on retire l'erreur
     */
    const mark = (field, message) => {
      let box = field.parentElement?.querySelector(':scope > .ms-field-error');
      if (!message) {
        field.removeAttribute('aria-invalid');
        if (box) {
          const ids = (field.getAttribute('aria-describedby') || '').split(' ').filter((id) => id && id !== box.id);
          if (ids.length) field.setAttribute('aria-describedby', ids.join(' '));
          else field.removeAttribute('aria-describedby');
          box.remove();
        }
        return;
      }
      if (!box) {
        box = document.createElement('span');
        box.className = 'ms-field-error';
        box.id = `ms-field-error-${++uid}`;
        field.insertAdjacentElement('afterend', box);
        const ids = (field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
        field.setAttribute('aria-describedby', [...ids, box.id].join(' '));
      }
      box.textContent = message;
      field.setAttribute('aria-invalid', 'true');
    };

    const fieldsOf = (form) => form.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]), textarea');

    // Le contrôle du navigateur est coupé seulement ICI, une fois ce script
    // chargé : sans lui, les required natifs continuent de faire le travail.
    const arm = () => { for (const form of document.querySelectorAll('form[data-ms-guard]')) form.noValidate = true; };
    arm();
    document.addEventListener('DOMContentLoaded', arm);
    document.addEventListener('shopify:section:load', arm);

    // En capture, au niveau du document : on passe AVANT les envois en fetch
    // branchés sur le formulaire (l'échantillon offert), et on les arrête.
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-ms-guard]')) return;
      let first = null;
      for (const field of fieldsOf(form)) {
        const message = problem(field);
        mark(field, message);
        if (message && !first) first = field;
      }
      if (first) {
        event.preventDefault();
        event.stopImmediatePropagation();
        first.focus();
        return;
      }
      // La fiche cliente d'abord (une seule fois), le message ensuite.
      if (form.dataset.msCustomer && !form.dataset.msCustomerSent && createCustomer(form, event.submitter)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    const customerForm = () => document.querySelector('form[data-ms-customer-form]');

    /**
     * Arme hCaptcha sur le formulaire caché, comme Shopify le fait quand on
     * touche un champ : un « change » qui remonte jusqu'au document.
     * @returns {Promise<boolean>} vrai une fois le formulaire armé
     */
    const armCustomerForm = async () => {
      const cf = customerForm();
      if (!cf) return false;
      const bound = () => Boolean(cf.dataset.hcaptchaBound || cf.dataset.recaptchaBound);
      if (bound()) return true;
      cf.dispatchEvent(new Event('change', { bubbles: true }));
      for (let waited = 0; waited < 3000 && !bound(); waited += 150) await new Promise((r) => window.setTimeout(r, 150));
      return bound();
    };

    // On arme tôt : dès que la personne touche un formulaire de message, le
    // formulaire caché se prépare. À l'envoi, il est prêt, sans attente.
    document.addEventListener('focusin', (event) => {
      if (event.target instanceof HTMLElement && event.target.closest('form[data-ms-customer]')) armCustomerForm();
    });

    /**
     * La fiche cliente : on remplit le vrai formulaire client caché et on
     * l'envoie normalement, dans un cadre invisible (la page ne bouge pas).
     * Shopify y ajoute son jeton anti-robot. Dès que le cadre a répondu, ou
     * au plus tard après six secondes, le message part à son tour : il ne
     * doit JAMAIS être perdu à cause de la fiche.
     * @param {HTMLFormElement} form le formulaire de message
     * @param {HTMLElement|null} submitter le bouton cliqué
     * @returns {boolean} vrai si l'envoi du message est retenu le temps de la fiche
     */
    const createCustomer = (form, submitter) => {
      const cf = customerForm();
      const val = (name) => form.querySelector(`[name="${name}"]`)?.value.trim() ?? '';
      const email = val('contact[email]');
      if (!cf || !email) return false;

      const set = (key, value) => { const el = cf.querySelector(`[data-ms-cf="${key}"]`); if (el) el.value = value; };
      const phone = val('contact[phone]');
      set('email', email);
      set('first', val('contact[Prénom]'));
      set('last', val('contact[Nom]'));
      set('note-phone', phone);
      set('note-origin', form.dataset.msCustomer);
      set('note-pref', form.querySelector('[name="contact[Réponse sur WhatsApp]"]')?.checked ? 'Réponse sur WhatsApp' : '');
      set('tags', `formulaire-contact, origine-${form.dataset.msCustomer}`);
      // Un champ vide part quand même : on retire du formulaire ce qui n'a pas de valeur.
      for (const el of cf.querySelectorAll('[data-ms-cf]')) el.disabled = !el.value;

      let frame = document.querySelector('iframe[name="ms-customer-frame"]');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.name = 'ms-customer-frame';
        frame.title = '';
        frame.hidden = true;
        frame.tabIndex = -1;
        frame.setAttribute('aria-hidden', 'true');
        document.body.append(frame);
      }
      cf.target = frame.name;

      const button = submitter ?? form.querySelector('[type="submit"]');
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }

      let released = false;
      const release = () => {
        if (released) return;
        released = true;
        form.dataset.msCustomerSent = '1';
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        if (form.requestSubmit) form.requestSubmit(button ?? undefined);
        else form.submit();
      };
      window.setTimeout(release, 6000);

      armCustomerForm().then((armed) => {
        // Pas armé : Shopify avalerait l'envoi. On n'insiste pas, le message part.
        if (!armed) { release(); return; }
        const startedAt = Date.now();
        // Certains navigateurs signalent d'abord le chargement du cadre vide : on l'ignore.
        frame.addEventListener('load', () => { if (Date.now() - startedAt > 300) window.setTimeout(release, 100); });
        try {
          if (cf.requestSubmit) cf.requestSubmit();
          else cf.submit();
        } catch {
          release();
        }
      });
      return true;
    };

    // L'erreur s'efface dès que le champ redevient bon : on ne gronde pas
    // quelqu'un qui est en train de corriger.
    document.addEventListener('input', (event) => {
      const field = event.target;
      if (!(field instanceof HTMLElement) || field.getAttribute('aria-invalid') !== 'true') return;
      if (!field.closest('form[data-ms-guard]')) return;
      if (!problem(field)) mark(field, '');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-pose-kit"] && !Shopify.designMode) return;
  try {
    /**
   * « Préparez votre pose ». Sur la fiche, le bloc d'achat appelle items()
   * au moment de commander et cents() pour son total. Au panier, chaque case
   * remet le panier d'accord : les trois cochées = une ligne Kit de pose.
   */
  class MsPoseKit extends HTMLElement {
    #busy = false;

    connectedCallback() {
      this.inputs = [...this.querySelectorAll('[data-ms-kit-item]')];
      this.deal = this.querySelector('[data-ms-kit-deal]');
      this.status = this.querySelector('[data-ms-kit-status]');
      for (const input of this.inputs) input.addEventListener('change', () => this.#onChange());
    }

    get #allIn() { return this.inputs.length > 0 && this.inputs.every((i) => i.checked); }

    /** Les lignes à ajouter avec le décor. */
    items() {
      if (this.hidden) return [];
      if (this.#allIn) return [{ id: Number(this.dataset.kitId), quantity: 1 }];
      return this.inputs.filter((i) => i.checked).map((i) => ({ id: Number(i.dataset.id), quantity: 1 }));
    }

    /** Le montant des cases cochées, en centimes. */
    cents() {
      if (this.hidden) return 0;
      if (this.#allIn) return Number(this.dataset.kitPrice) || 0;
      return this.inputs.filter((i) => i.checked).reduce((sum, i) => sum + (Number(i.dataset.price) || 0), 0);
    }

    /** Tout décocher (support adhésif choisi). */
    clear() {
      for (const input of this.inputs) input.checked = false;
      this.#showDeal();
    }

    #showDeal() { if (this.deal) this.deal.hidden = !this.#allIn; }

    #onChange() {
      this.#showDeal();
      this.dispatchEvent(new CustomEvent('ms-kit:change', { bubbles: true }));
      if (this.dataset.mode === 'cart') this.#sync();
    }

    /** Au panier : quantités voulues pour les trois accessoires et le kit. */
    async #sync() {
      if (this.#busy) return;
      this.#busy = true;
      const all = this.#allIn;
      const updates = { [this.dataset.kitId]: all ? 1 : 0 };
      for (const input of this.inputs) updates[input.dataset.id] = !all && input.checked ? 1 : 0;
      const drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
      const sectionId = this.closest('cart-drawer') ? drawer?.dataset?.sectionId : null;
      for (const input of this.inputs) input.disabled = true;
      if (this.status) this.status.textContent = '';
      try {
        const url = (window.Theme?.routes?.cart_update_url ?? '/cart/update').replace(/\.js$/, '') + '.js';
        const body = { updates };
        if (sectionId) Object.assign(body, { sections: sectionId, sections_url: window.location.pathname });
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.description || 'cart');
        if (!sectionId) { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { resource: {}, data: { source: 'ms-pose-kit', itemCount: data.item_count, sections: data.sections } },
        }));
      } catch {
        if (this.status) this.status.textContent = "Le panier n'a pas pu être mis à jour. Réessayez dans un instant.";
        for (const input of this.inputs) input.disabled = false;
      } finally {
        this.#busy = false;
      }
    }
  }

  if (!customElements.get('ms-pose-kit')) customElements.define('ms-pose-kit', MsPoseKit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-quiz-matiere"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-quiz-matiere')) {
    const MSQM_KEY = 'ms-quiz-matiere';
    // Même fonction que sections/ms-quiz : numéro de visiteur gardé par le navigateur, source d'arrivée, test.
    window.msQuizWho = window.msQuizWho || (() => {
      const rnd = () => { const b = new Uint8Array(10); crypto.getRandomValues(b); return [...b].map((x) => x.toString(36).padStart(2, '0')).join('').slice(0, 16); };
      let visitor = '';
      try {
        visitor = localStorage.getItem('ms-visiteur') || '';
        if (!/^[a-z0-9]{10,24}$/.test(visitor)) { visitor = rnd(); localStorage.setItem('ms-visiteur', visitor); }
      } catch (e) {}
      let src = '';
      try { src = sessionStorage.getItem('ms-source') || ''; } catch (e) {}
      if (!src) {
        const q = new URLSearchParams(location.search);
        let ref = '';
        try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
        const own = location.hostname.replace(/^www\./, '');
        if (q.get('gclid') || q.get('gbraid') || q.get('wbraid')) src = 'google-ads';
        else if (q.get('fbclid') && /cpc|paid|ads/i.test(q.get('utm_medium') || '')) src = 'meta-ads';
        else if (q.get('utm_source')) src = q.get('utm_source');
        else if (ref && !ref.endsWith(own) && !ref.endsWith('myshopify.com')) src = ref;
        else src = ref ? 'interne' : 'direct';
        try { sessionStorage.setItem('ms-source', src); } catch (e) {}
      }
      const sh = window.Shopify || {};
      return { visitor, src, test: !!(sh.designMode || (sh.theme && sh.theme.role && sh.theme.role !== 'main')) };
    });
    /** Supports : mot-clé cherché dans le nom de la variante, et la phrase « pourquoi ». */
    const MSQM_RESULTS = {
      etanche: { name: "L'Étanche", why: 'Fibre de verre résinée, pour l’eau directe : douche, baignoire, crédence.' },
      amovible: { match: 'amovible', why: 'Se pose sans colle et se retire d’un seul tenant. Pensé pour la location.' },
      vinyle: { match: 'vinyle', why: 'Lessivable, au grain fin. Le choix sûr pour la cuisine, la salle de bain et les murs très sollicités.' },
      lisse: { match: 'lisse', why: 'Fin et lumineux. Notre support le plus accessible.' },
      mat: { match: 'intissé mat', why: 'Un mat velouté, lavable et résistant aux rayures. L’équilibre juste.' },
    };
    const MSQM_ORDER = ['piece', 'statut', 'contraintes', 'budget', 'resultat'];
    /** Libellés de la note de commande. */
    const MSQM_LABELS = {
      'chambre-salon': 'Chambre ou salon', cuisine: 'Cuisine', 'salle-de-bain': 'Salle de bain', douche: 'Intérieur de douche',
      'entree-couloir-bureau': 'Entrée, couloir, bureau', proprietaire: 'Propriétaire', locataire: 'Locataire',
      'enfants-animaux': 'Enfants ou animaux', 'lavage-frequent': 'Lavage fréquent', rien: 'Rien de particulier',
      accessible: 'Le plus accessible', rapport: 'Le meilleur rapport qualité-prix', 'haut-de-gamme': 'Le plus haut de gamme',
    };

    class MsQuizMatiere extends HTMLElement {
      #controller = null;
      #answers = { piece: '', statut: '', contraintes: [], budget: '' };
      #history = [];
      #step = 'piece';
      /** Le quiz en cours, tel qu'il part au tableau de bord. */
      #session = null;
      #sent = '';

      connectedCallback() {
        this.#controller = new AbortController();
        const signal = this.#controller.signal;
        this.panel = this.querySelector('[data-msqm-panel]');
        this.opener = this.querySelector('[data-msqm-open]');
        this.isOpen = this.hasAttribute('data-open');
        try { this.supports = JSON.parse(this.querySelector('script[data-msqm-supports]')?.textContent || 'null'); } catch { this.supports = null; }
        this.opener?.addEventListener('click', () => this.#toggle(), { signal });
        this.addEventListener('click', (event) => this.#onClick(event), { signal });
        this.querySelector('[data-msqm-etanche]')?.addEventListener('click', () => this.#mark('etanche'), { signal });
        this.querySelector('[data-msqm-browse]')?.addEventListener('click', () => this.#mark('chosen'), { signal });
        if (this.isOpen) this.#show('piece', false);
        // Quitter la page en cours de route : le quiz commencé est envoyé tel quel.
        window.addEventListener('pagehide', () => this.#send(), { signal });
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') this.#send(); }, { signal });
        this.#restore();
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      #toggle(force) {
        if (this.isOpen) return;
        const open = force ?? this.panel.hidden;
        this.panel.hidden = !open;
        this.opener?.setAttribute('aria-expanded', String(open));
        if (open) {
          this.#begin();
          this.#show(this.#step, false);
        }
      }

      #onClick(event) {
        const opt = event.target.closest('.msqm__opt');
        if (opt) return this.#answer(opt);
        if (event.target.closest('[data-msqm-back]')) return this.#back();
        if (event.target.closest('[data-msqm-restart]')) return this.#restart();
        if (event.target.closest('[data-msqm-next]')) return this.#afterConstraints();
        if (event.target.closest('[data-msqm-choose]')) return this.#choose();
      }

      #answer(opt) {
        this.#begin();
        const value = opt.dataset.value;
        if (this.#step === 'contraintes') {
          const group = [...this.querySelectorAll('[data-step="contraintes"] .msqm__opt')];
          const on = opt.getAttribute('aria-pressed') !== 'true';
          if (on && opt.hasAttribute('data-alone')) group.forEach((b) => b.setAttribute('aria-pressed', 'false'));
          if (on && !opt.hasAttribute('data-alone')) group.filter((b) => b.hasAttribute('data-alone')).forEach((b) => b.setAttribute('aria-pressed', 'false'));
          opt.setAttribute('aria-pressed', String(on));
          this.#answers.contraintes = group.filter((b) => b.getAttribute('aria-pressed') === 'true').map((b) => b.dataset.value);
          this.querySelector('[data-msqm-next]').disabled = this.#answers.contraintes.length === 0;
          return;
        }
        this.#answers[this.#step] = value;
        if (this.#step === 'piece') {
          if (value === 'douche') return this.#go('resultat');
          return this.#go('statut');
        }
        if (this.#step === 'statut') return this.#go(value === 'locataire' ? 'resultat' : 'contraintes');
        if (this.#step === 'budget') return this.#go('resultat');
      }

      /** Le budget est toujours demandé (4/4), même si une contrainte décide déjà du support. */
      #afterConstraints() {
        this.#go('budget');
      }

      #go(step) {
        this.#history.push(this.#step);
        this.#show(step);
      }

      /** En revenant en arrière, la réponse de l'écran quitté est effacée : le résultat suit toujours l'écran affiché. */
      #back() {
        const prev = this.#history.pop();
        if (!prev) return this.#toggle(false);
        if (this.#step !== 'resultat' && this.#step !== 'contraintes') this.#answers[this.#step] = '';
        this.#answers[prev] = prev === 'contraintes' ? this.#answers.contraintes : '';
        this.#show(prev);
      }

      #restart() {
        this.#send();
        this.#answers = { piece: '', statut: '', contraintes: [], budget: '' };
        this.#history = [];
        for (const b of this.querySelectorAll('[data-multi]')) b.setAttribute('aria-pressed', 'false');
        this.#session = null;
        this.#begin();
        this.#show('piece');
      }

      #show(step, focus = true) {
        this.#step = step;
        for (const el of this.querySelectorAll('[data-step]')) el.hidden = el.dataset.step !== step;
        const n = Math.min(4, MSQM_ORDER.indexOf(step) + 1);
        const count = this.querySelector('[data-msqm-count]');
        if (count) count.textContent = step === 'resultat' ? '' : `${n}/4`;
        const bar = this.querySelector('[data-msqm-bar]');
        if (bar) bar.style.transform = `scaleX(${step === 'resultat' ? 1 : n / 4})`;
        const next = this.querySelector('[data-msqm-next]');
        next.hidden = step !== 'contraintes';
        if (step === 'contraintes') next.disabled = this.#answers.contraintes.length === 0;
        // Quiz ouvert d'emblée : rien à fermer, pas de « Retour » sur la première question.
        this.querySelector('[data-msqm-back]').hidden = step === 'resultat' || (this.isOpen && step === 'piece');
        this.querySelector('[data-msqm-restart]').hidden = step !== 'resultat';
        if (this.#session) this.#session.step = step;
        if (step === 'resultat') this.#renderResult();
        if (focus) this.querySelector(`[data-step="${step}"] .msqm__q`)?.focus({ preventScroll: true });
      }

      /**
       * Dans l'ordre, la première règle qui s'applique l'emporte. Question 3 (décision de Cedric, 28 oct.) :
       * « Lavage fréquent » mène au Vinyle (lessivable), « Enfants ou animaux » à L'Intissé Mat
       * (lavable, résistant aux rayures) ; « Rien de particulier » laisse décider le budget.
       */
      #decide() {
        const a = this.#answers;
        if (a.piece === 'douche' && this.dataset.etancheUrl) return 'etanche';
        if (a.statut === 'locataire') return 'amovible';
        if (['salle-de-bain', 'cuisine'].includes(a.piece)) return 'vinyle';
        if (a.contraintes.includes('lavage-frequent')) return 'vinyle';
        if (a.contraintes.includes('enfants-animaux')) return 'mat';
        if (a.budget === 'accessible') return 'lisse';
        if (a.budget === 'haut-de-gamme') return 'vinyle';
        return 'mat';
      }

      #radioFor(key) {
        const match = MSQM_RESULTS[key]?.match;
        if (!match) return null;
        const scope = this.closest('ms-buybox') ?? document;
        return [...scope.querySelectorAll('[data-ms-support]')].find((r) => (r.dataset.name || '').toLowerCase().includes(match)) ?? null;
      }

      #renderResult() {
        const key = this.#decide();
        this.result = key;
        const data = MSQM_RESULTS[key];
        const radio = this.#radioFor(key);
        // Hors fiche décor (page d'accueil), le nom et le prix viennent de la page (data-msqm-supports).
        const sup = this.supports?.[key];
        const name = key === 'etanche' ? data.name : radio?.dataset.name || sup?.name || data.name || '';
        this.resultName = name;
        this.querySelector('[data-msqm-name]').textContent = name;
        const price = this.querySelector('[data-msqm-price]');
        if (key === 'etanche') {
          // Le kit d'étanchéité est compris dans le prix au m².
          price.textContent = `${this.dataset.etanchePrice} / m², kit inclus`;
        } else if (radio) {
          const row = radio.closest('.msbb__support');
          const amount = row?.querySelector('.msbb__support-amount');
          const unit = row?.querySelector('.msbb__support-unit');
          price.innerHTML = amount ? `${amount.innerHTML} ${unit ? unit.textContent : ''}` : '';
        } else {
          price.innerHTML = sup?.price ? `${sup.price} / m²` : '';
        }
        this.querySelector('[data-msqm-why]').textContent = data.why;
        const choose = this.querySelector('[data-msqm-choose]');
        const link = this.querySelector('[data-msqm-etanche]');
        const browse = this.querySelector('[data-msqm-browse]');
        choose.hidden = key === 'etanche' || !radio;
        link.hidden = key !== 'etanche';
        if (key === 'etanche') link.href = this.dataset.etancheUrl;
        if (browse) {
          browse.hidden = key === 'etanche' || Boolean(radio) || !this.dataset.browseUrl;
          browse.href = this.dataset.browseUrl || '#';
          // « en Vinyle », pas « en Le Vinyle » : sans l'article du nom de la matière.
          browse.textContent = `Voir nos décors en ${name.replace(/^(L['’]|Le |La )/, '')}`;
        }
        this.querySelector('[data-msqm-status]').textContent = `Notre recommandation : ${name}.`;
        // Gardé pour pré-cocher cette matière sur les fiches décors (aussi depuis la page d'accueil).
        try { if (key !== 'etanche') localStorage.setItem(MSQM_KEY, key); } catch (e) {}
        const a = this.#answers;
        (window.dataLayer = window.dataLayer || []).push({
          event: 'quiz_matiere',
          resultat: key,
          piece: a.piece,
          statut: a.statut,
          contraintes: a.contraintes.join(','),
          budget: a.budget,
        });
        if (this.#session) this.#session.result = key;
        this.#send();
        this.#noteCart();
      }

      #choose() {
        const radio = this.#radioFor(this.result);
        if (!radio) return;
        if (!radio.checked) radio.click();
        this.#mark('chosen');
        this.#toggle(false);
        radio.focus({ preventScroll: false });
      }

      /** Sur une autre fiche : la matière recommandée est pré-cochée, sauf si l'adresse en impose une. */
      #restore() {
        let key = '';
        try { key = localStorage.getItem(MSQM_KEY) || ''; } catch (e) {}
        if (!key || new URL(window.location.href).searchParams.has('variant')) return;
        const radio = this.#radioFor(key);
        if (radio && !radio.checked) requestAnimationFrame(() => radio.click());
      }

      /* ── Suivi ── */

      #begin() {
        if (this.#session) return;
        const bytes = new Uint8Array(10);
        crypto.getRandomValues(bytes);
        this.#session = {
          id: [...bytes].map((b) => b.toString(36).padStart(2, '0')).join('').slice(0, 16),
          t: Date.now(),
          decor: this.dataset.decor || '',
          device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
          step: 'piece',
          result: '',
          chosen: false,
          etanche: false,
          ...window.msQuizWho(),
        };
        this.#sent = '';
      }

      #mark(what) {
        if (!this.#session) return;
        this.#session[what] = true;
        this.#send();
        if (what === 'chosen') this.#noteCart();
      }

      #payload() {
        const s = this.#session;
        const a = this.#answers;
        return { ...s, piece: a.piece, statut: a.statut, contraintes: a.contraintes, budget: a.budget };
      }

      /** Un envoi par changement réel : rien ne part si le quiz n'a pas bougé depuis le dernier envoi. */
      #send() {
        const endpoint = this.dataset.track;
        if (!endpoint || !this.#session || !this.#answers.piece) return;
        const body = JSON.stringify(this.#payload());
        if (body === this.#sent) return;
        this.#sent = body;
        try {
          const url = new URL('/quiz', endpoint).toString();
          const blob = new Blob([body], { type: 'text/plain' });
          if (!navigator.sendBeacon?.(url, blob)) fetch(url, { method: 'POST', body, keepalive: true, mode: 'no-cors' }).catch(() => {});
        } catch (e) {}
      }

      /** La note de la commande : lisible dans l'admin, et reliée au quiz par _quiz_id. */
      #noteCart() {
        if (!this.#session || !this.result) return;
        const a = this.#answers;
        const parts = [`${this.resultName || this.result} recommandé${this.#session.chosen ? ' (choisi)' : ''}`, MSQM_LABELS[a.piece]];
        if (a.statut) parts.push(MSQM_LABELS[a.statut]);
        for (const c of a.contraintes) parts.push(MSQM_LABELS[c]);
        if (a.budget) parts.push(`Budget : ${MSQM_LABELS[a.budget]}`);
        if (this.dataset.decorTitle) parts.push(`Décor : ${this.dataset.decorTitle}`);
        fetch(`${window.Theme?.routes?.cart_url ?? '/cart'}/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Quiz matière': parts.filter(Boolean).join(' · '), _quiz_id: this.#session.id } }),
        }).catch(() => {});
      }
    }
    customElements.define('ms-quiz-matiere', MsQuizMatiere);
  }
  } catch(e) { console.error(e); }
})();

})();
